interface LoadingSpinnerProps {
  message?: string;
}

export function LoadingSpinner({ message = "Laster..." }: LoadingSpinnerProps) {
  return (
    <div className="flex justify-center items-center py-12">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mr-3"></div>
      <span>{message}</span>
    </div>
  );
}